module.exports = __webpack_public_path__ + "assets/img/self-1-big.d6dad628.png";